export default "__VITE_ASSET__BkO7Gt8Z__"